"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicationScoreCardSchema = void 0;
exports.applicationScoreCardSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'cmhcAccountNumber',
        'applicationIDTimestamp',
        'applicationScorecardModelRatingCode',
        'applicationScorecardTotalPoints',
        'assetEquityPoints',
        'bankOfCanadaMonthlyRateDifferentialPoints',
        'borrowerBeaconPoints',
        'borrowerCountPoints',
        'borrowerEmiliScorePoints',
        'borrowerGeminiScorePoints',
        'borrowerModelRatingPoints',
        'businessSourcePoints',
        'cma12MonthsProvincialPriceChangePoints',
        'cma24MonthsProvincialPriceChangePoints',
        'cmaProvincialUnemploymentRatePoints',
        'cmaUnemploymentRatePoints',
        'coBorrowerBeaconPoints',
        'coBorrowerEmiliScorePoints',
        'coBorrowerModelRatingPoints',
        'dayToClosingPoints',
        'grossDebtServiceRatioPoints',
        'guarantorPresentPoints',
        'heatingLendingValuePoints',
        'hedonicPramPoints',
        'interestTypePoints',
        'lenderLoanToValuePoints',
        'lenderRequestedReferralPoints',
        'loanAmortizationPeriodPoints',
        'loanEmiliMonthlyRateInterestPoints',
        'loanEmiliWeeklyRateInterestPoints',
        'loanSecurityTypePoints',
        'loanTermPeriodPoints',
        'nonMortgageDebtPoints',
        'otherEquityPoints',
        'pramLoanToValuePoints',
        'premiumChargedLoanPoints',
        'previousSellingPriceRefinancePoints',
        'priceChange12MonthsPoints',
        'priceIndexPramPoints',
        'propertyImprovementPoints',
        'purchaseRefinanceMonthlyPoints',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'registeredRetirementSavingsPlanEquityPoints',
        'repeatPriceIndexTypeCode',
        'scorecardTypeCode',
        'startingApplicationScorecardModelRatingCode',
        'sweatEquityPoints',
        'taxProxyHedonicPoints',
        'taxProxyPriceIndexPoints',
        'topUpPramPoints',
        'totalDebtServiceRatioPoints',
    ],
    properties: {
        cmhcAccountNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 999999999999,
            errorMessage: 'should be an integer between with up to 12 digits',
        },
        applicationIDTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        applicationScorecardModelRatingCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        applicationScorecardTotalPoints: {
            type: 'number',
            maximum: 99999,
            minimum: 0,
            errorMessage: 'should be a number with up to 5 digits in total',
        },
        assetEquityPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        bankOfCanadaMonthlyRateDifferentialPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        borrowerBeaconPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        borrowerCountPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        borrowerEmiliScorePoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        borrowerGeminiScorePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        borrowerModelRatingPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        businessSourcePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        cma12MonthsProvincialPriceChangePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        cma24MonthsProvincialPriceChangePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        cmaProvincialUnemploymentRatePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        cmaUnemploymentRatePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        coBorrowerBeaconPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        coBorrowerEmiliScorePoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        coBorrowerModelRatingPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        dayToClosingPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        grossDebtServiceRatioPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        guarantorPresentPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        heatingLendingValuePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        hedonicPramPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        interestTypePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        lenderLoanToValuePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        lenderRequestedReferralPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        loanAmortizationPeriodPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        loanEmiliMonthlyRateInterestPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        loanEmiliWeeklyRateInterestPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        loanSecurityTypePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        loanTermPeriodPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        metMajorPreviousTwelveMonthPriceIndexPercent: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        metMajorPreviousTwentyFourMonthPriceIndexPercent: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        metMajorPreviousCurrentPriceIndexPercent: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        nonMortgageDebtPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        otherEquityPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        pramLoanToValuePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        premiumChargedLoanPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        previousSellingPriceRefinancePoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        priceChange12MonthsPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        priceIndexPramPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        propertyImprovementPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        provincialPrevious12MonthPriceIndexPercent: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        provincialPrevious24MonthPriceIndexPercent: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        provincialCurrentPriceIndexPercent: {
            type: ['number', 'null'],
            maximum: 99999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        purchaseRefinanceMonthlyPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        registeredRetirementSavingsPlanEquityPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        repeatPriceIndexTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        scorecardTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        startingApplicationScorecardModelRatingCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        sweatEquityPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        taxProxyHedonicPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        taxProxyPriceIndexPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        topUpPramPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        totalDebtServiceRatioPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
    },
};
